import React from "react"
import { useFormContext } from "react-hook-form"
import { Section, SingleShorty, TwoColumnRow } from "./Shared"
import L10n from "../../../lib/carrot-l10n"
import GenderIdentityChoices from "../../../content/GenderIdentityChoices"
import SexChoices from "../../../content/SexChoices"
import { CompleteFormSelect } from "../atoms/forms/FormSelect"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { regexes } from "utils/Regexes"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FirstName = () => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormInput
      name="partnerFirstName"
      label={l`client.accountSettings.firstNameLabel`}
      errors={errors}
      ref={register}
    />
  )
}

const LastName = () => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormInput
      name="partnerLastName"
      label={l`client.accountSettings.lastNameLabel`}
      errors={errors}
      ref={register}
    />
  )
}

const Email = () => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormInput
      name="partnerEmail"
      label={l`client.accountSettings.partnerEmailLabel`}
      errors={errors}
      ref={register({
        pattern: {
          value: regexes.email,
          message: l`client.invalidEmail`
        }
      })}
    />
  )
}

const PartnerDateOfBirth = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      type="date"
      name="partnerDateOfBirth"
      label={l`client.accountSettings.dateOfBirthLabel`}
      errors={errors}
      ref={register}
    />
  )
}

const PartnerSex = () => {
  const { errors, register } = useFormContext()

  return <CompleteFormSelect name={"partnerSex"} label={l`Sex`} ref={register} options={SexChoices} errors={errors} />
}

const PartnerGenderIdentity = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormSelect
      name={"partnerGenderIdentity"}
      label={l`Gender Identity`}
      ref={register}
      options={GenderIdentityChoices}
      errors={errors}
    />
  )
}

const PartnerDetails = () => (
  <Section title="Partner details">
    <TwoColumnRow left={<FirstName />} right={<LastName />} />
    <SingleShorty>
      <Email />
    </SingleShorty>
    <SingleShorty>
      <PartnerDateOfBirth />
    </SingleShorty>
    <TwoColumnRow left={<PartnerSex />} right={<PartnerGenderIdentity />} />
  </Section>
)

export default PartnerDetails
